import React, { useEffect, useState } from 'react';
import { locales } from '../../../translations/locales';
import Location from './Location';
import Qualification from './Qualification';
import { _$ } from '../../../controllers/dom';
import { hhmmss } from '../../../controllers/dates';
import { removeMarker } from '../../../controllers/markers';

const NewAlert = (props) => {
    const { setNewAlert, locale, theme, shareAlert, incidentsCategories, incidents, places, alert, automaticLocation, departments,
        setCityFocused,
        setDepartmentFocused,
        departmentFocused,
        setMarker,
        selectedGtaCity,
        selectedGtaStreet,
    } = props;
    const [menu, setMenu] = useState('Location');
    const [location, setLocation] = useState(false);
    const [qualification, setQualification] = useState(false);
    const [time, setTime] = useState(0);
    const [timerOn, setTimerOn] = useState(true);
    const [danger, setDanger] = useState(false);
    const [updatedQualification, setUpdatedQualification] = useState({
        informations: '',
        category: '',
        qualification: '',
        place: {},
    });

    useEffect(() => {
        if (alert && typeof alert === 'object') {
            setTime(alert.time);
            setLocation(alert.location);
            setQualification(alert.qualification);
            setDanger(alert.danger);
        }
    }, [alert]);

    const onChangeQualification = (e) => {
        const { id, value } = e.target;
        setUpdatedQualification((prevState) => ({
            ...prevState,
            [id]: value !== undefined ? value : prevState[id] || '',
        }));
    };

    useEffect(() => {
        let timerInterval;
        if (timerOn) {
            timerInterval = setInterval(() => {
                setTime((prevTime) => prevTime + 1);
            }, 1000);
        }
        return () => clearInterval(timerInterval);
    }, [timerOn]);

    const cancelAlert = () => {
        setTimerOn(false);
        setNewAlert(false);
    };

    const sendAlert = (sgo) => {
        setTimerOn(false);
        const _alert = {
            location,
            qualification,
            time,
            danger,
            number: alert ? alert.number : null,
        };
        shareAlert(_alert, sgo);
        if (!sgo) {
            setNewAlert(false);
        }
    };

    const validateLocation = (value) => {
        if (value) {
            setLocation({
                city: _$('city').value,
                address: _$('address').value,
                numero: _$('numero').value,
                stage: _$('stage').value,
                gate: _$('gate').value,
                building: _$('building').value,
                code: _$('code').value,
                observations: _$('observations').value,
                lngLat: { lng: _$('lngLat').innerHTML.split(';')[0], lat: _$('lngLat').innerHTML.split(';')[1] },
            });
            setMenu('Qualification');
            removeMarker('NEW_CALL');
        } else {
            setLocation(false);
            setMenu('Location');
        }
    };

    const validateQualification = (value) => {
        if (value) {
            setQualification({
                informations: _$('informations').value,
                category: updatedQualification.category,
                qualification: updatedQualification.qualification,
                place: updatedQualification.place,
            });
        } else {
            setQualification(false);
            setMenu('Qualification');
        }
    };

    const traitement = (stage) => {
        if (stage === 'Qualification' && location) {
            setMenu('Qualification');
        }
    };

    useEffect(() => {
        if (location) {
            setMenu('Qualification');
        }
    }, [location]);

    return (
        <div className='col-8'>
            <div className='row'>
                <div className='col-12 m-1'>
                    <button className='btn btn-danger btn-sm m-2 pl-4 pr-4' onClick={() => cancelAlert()}>
                        {locales[locale].sga.cancelAlert}
                    </button>
                </div>
            </div>
            <div className='row'>
                <Location
                    locale={locale}
                    menu={menu}
                    setMenu={traitement}
                    theme={theme}
                    setLocation={validateLocation}
                    location={location}
                    automaticLocation={automaticLocation}
                    departments={departments}
                    setCityFocused={setCityFocused}
                    setDepartmentFocused={setDepartmentFocused}
                    departmentFocused={departmentFocused}
                    setMarker={setMarker}
                    selectedGtaCity={selectedGtaCity}
                    selectedGtaStreet={selectedGtaStreet}
                />
                <Qualification
                    locale={locale}
                    menu={menu}
                    setMenu={traitement}
                    theme={theme}
                    location={location}
                    setQualification={validateQualification}
                    qualification={qualification}
                    incidentsCategories={incidentsCategories}
                    incidents={incidents}
                    places={places}
                    updatedQualification={updatedQualification}
                    onChangeQualification={onChangeQualification}
                    setUpdatedQualification={setUpdatedQualification}
                />
                {location && qualification ? (
                    <div className='col-4'>
                        <button className={`btn btn-${!danger || danger === 1 ? 'danger' : 'light'} btn-sm pl-4 pr-4 w-100`} onClick={() => setDanger(1)}>
                            {locales[locale].sga.veryUrgent}
                        </button>
                        <button className={`btn btn-${!danger || danger === 2 ? 'warning' : 'light'} btn-sm pl-4 pr-4 w-100`} onClick={() => setDanger(2)}>
                            {locales[locale].sga.urgent}
                        </button>
                        <button className={`btn btn-${!danger || danger === 3 ? 'light' : 'light'} btn-sm pl-4 pr-4 w-100`} onClick={() => setDanger(3)}>
                            {locales[locale].sga.normal}
                        </button>
                        <button className={`btn btn-${!danger || danger === 4 ? 'secondary' : 'light'} btn-sm pl-4 pr-4 w-100`} onClick={() => setDanger(4)}>
                            {locales[locale].sga.low}
                        </button>
                    </div>
                ) : null}
            </div>
            <div className='row'>
                <div className='col-12'>
                    <div className={`alert alert-${theme === 'DARK' ? 'dark' : 'light'} h-100`}>
                        <div className='row'>
                            <div className='col-4'>
                                <h6 className='alert-heading'>{locales[locale].sga.duration}: {hhmmss(time)}</h6>
                                <h6 className='alert-heading'>{locales[locale].sga.callBackNumber}:
                                    <input type='text' className='form-control' id='callBackNumber' />
                                </h6>
                            </div>
                            <div className='col-4'>
                                {
                                    location ? (
                                        <li className='alert-heading text-success'>{locales[locale].sga.locationValid}</li>
                                    ) : (
                                        <li className='alert-heading text-danger'>{locales[locale].sga.locationInvalid}</li>
                                    )
                                }
                                {
                                    qualification ? (
                                        <li className='alert-heading text-success'>{locales[locale].sga.qualificationValid}</li>
                                    ) : (
                                        <li className='alert-heading text-danger'>{locales[locale].sga.waitingLocation}</li>
                                    )
                                }
                            </div>
                            {location && qualification ? (
                                <div className='col-4'>
                                    <button
                                        className='btn btn-success pl-4 pr-4 pt-4 pb-4 w-100'
                                        id='btn-engage'
                                        onClick={() => sendAlert(true)}
                                    >
                                        {locales[locale].sga.engage}
                                    </button>
                                    <button
                                        className='btn btn-info pl-4 pr-4 w-100 mt-2'
                                        id='btn-shareAndReturn'
                                        onClick={() => sendAlert(false)}
                                    >
                                        {locales[locale].sga.shareAndReturn}
                                    </button>
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NewAlert;
